import { NgModule } from '@angular/core';
import { YacareSpinnerComponent } from './yacare-spinner.component';

@NgModule({
  declarations: [YacareSpinnerComponent],
  exports: [YacareSpinnerComponent]
})
export class YacareSpinnerModule {}
